import {
    request,
    requestPublic
} from './request.js'
// 获取专业类别列表
export function getMajorCategoryList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorCategory/GetMajorCategoryList',
        method: 'get',
        params: {
            Name: obj.name,
            IsPtzsb: obj.isPtzsb,
            PageIndex: obj.pageIndex,
            PageSize: obj.pageSize
        }
    })
}

//获取专业类别下拉
export function getMajorCategory(isPtzsb) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorCategory/GetMajorCategory',
        method: 'get',
        params:{
            IsPtzsb:isPtzsb
        }
    })
}

//添加专业类别
export function createMajorCategory(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorCategory/CreateMajorCategory',
        method: 'post',
        data: data
    })
}

//获取专业类别详情
export function getMajorCategoryDetail(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorCategory/GetMajorCategoryDetail',
        method: 'get',
        params: {
            id: id
        }
    })
}

//修改专业类别
export function updateMajorCategory(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorCategory/UpdateMajorCategory',
        method: 'post',
        data: data
    })
}

//删除专业类别
export function delMajorCategory(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/MajorCategory/DelMajorCategory',
        method: 'post',
        params: {
            id: id
        }
    })
}